import React, { useEffect } from 'react';

import { emailFieldError } from 'helpers/validators/pattern-validators';
import { Controller, useForm } from 'react-hook-form';

import { Button, Email, Input, InputGroup, PhoneNumberPicker } from 'components/FormComponents';

const EMAIL_COMPARE_ERROR_MESSAGE =
  'This email address belongs to the candidate or another referee. Please use a different email address.';
const CONTACT_COMPARE_ERROR_MESSAGE =
  'This contact number belongs to the candidate or another referee. Please use a different contact number.';

export const RefereeDetails = ({
  referee,
  candidate,
  referees = [],
  company,
  onSubmit = () => {},
}) => {
  const {
    reset,
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      id: referee.id,
      first_name: referee.first_name,
      last_name: referee.last_name,
      email: referee.email,
      contact_number: referee.contact_number,
      form_name: referee.form_name,
    },
  });

  const otherActiveReferees = referees.filter(
    other => other.id !== referee.id && !other.replaced_by && !other.deleted && !other.canceled,
  );
  const compareEmails = [candidate?.email, ...otherActiveReferees.map(other => other.email)].filter(
    Boolean,
  );
  const compareContacts = [
    candidate?.contact_number,
    ...otherActiveReferees.map(other => other.contact_number),
  ].filter(Boolean);

  useEffect(
    () =>
      reset({
        id: referee.id,
        first_name: referee.first_name,
        last_name: referee.last_name,
        email: referee.email,
        contact_number: referee.contact_number,
        form_name: referee.form_name,
      }),
    [referee],
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8">
      <div className="inline">
        <InputGroup title="First name">
          <Input
            name="first_name"
            register={register}
            validators={{ required: true }}
            placeholder="John"
          />
        </InputGroup>
        <InputGroup title="Last name">
          <Input
            name="last_name"
            register={register}
            validators={{ required: true }}
            placeholder="Doe"
          />
        </InputGroup>
      </div>
      <InputGroup title="Email">
        <Email
          name="email"
          register={register}
          validators={{ required: true }}
          placeholder="john@checkmate.com"
          compareEmailValidation
          compareEmail={compareEmails}
          compareErrorMessage={EMAIL_COMPARE_ERROR_MESSAGE}
          error={emailFieldError(errors?.email)}
        />
      </InputGroup>
      <InputGroup title="Form">
        <Input name="form_name" register={register} disabled={true} />
      </InputGroup>
      <InputGroup title="Contact Number">
        <Controller
          control={control}
          name="contact_number"
          rules={{
            validate: value => !compareContacts.includes(value) || CONTACT_COMPARE_ERROR_MESSAGE,
          }}
          render={({ field: { onChange, value } }) => (
            <PhoneNumberPicker
              value={value}
              onChange={onChange}
              defaultCountry={company?.country}
              error={errors?.contact_number}
            />
          )}
        />
      </InputGroup>
      <Button className="w-full" submit>
        Update
      </Button>
    </form>
  );
};
